/**
 * Maps filter values to departmentIds and/or location phones based on the value type.
 * Handles different scenarios for combining mapped values with additional location phones.
 * Useful for transforming the output of departmentId/locationPhone mapping utils to filter values for endpoints like
 * `ListThreads` and `CountThreads`.
 *
 * @param mappedValues - Array of values to be mapped (either department IDs or location phones)
 * @param valueType - Type of values in mappedValues ('departmentId' or 'locationPhone')
 * @param otherLocationPhones (optional) - Array of additional location phone numbers to include
 *
 * @returns Object containing departmentIds and/or locationPhones arrays based on the input configuration
 */
export const departmentIdLocationPhoneFilterMappingSelect = ({
  mappedValues,
  valueType,
  otherLocationPhones,
}: {
  mappedValues: string[];
  valueType: 'departmentId' | 'locationPhone';
  otherLocationPhones?: string[];
}): { departmentIds?: string[]; locationPhones?: string[] } => {
  if (!mappedValues.length && !otherLocationPhones?.length) {
    return {};
  } else if (!mappedValues.length && !!otherLocationPhones?.length) {
    return {
      locationPhones: otherLocationPhones,
    };
  } else if (valueType === 'departmentId' && otherLocationPhones?.length) {
    return {
      departmentIds: mappedValues,
      locationPhones: otherLocationPhones,
    };
  } else if (valueType === 'departmentId') {
    return {
      departmentIds: mappedValues,
    };
  } else if (valueType === 'locationPhone') {
    return {
      locationPhones: Array.from(new Set([...(otherLocationPhones ?? []), ...mappedValues])),
    };
  }

  return {};
};
